// The Girl and Her Piano - awards and screenings record.
//
// Single source of truth for /awards and /screenings. Everything came from
// the laurel and certificate files, festival emails and festival pages, not
// the older text lists, which had errors in the festival name, three
// placings and two years.
//
// Edit this file to change either page. Array order is page order.
//
// LINKS: every entry takes an optional `url`. Where one exists the festival
// name becomes a link; where it does not, it renders as plain text. Paste new
// ones in as festivals send them. No code changes needed.

export const totals = { festivals: 18, awards: 21 }

// The full record, small type, on the band at the foot of the page. Complete
// for Elaine's own reference; deliberately quiet for everyone else.
export const awardsParagraph = [
  'Global Trend Climate Change Film Festival 2026 \u2014 Joint Winner, Best Climate Film Award',
  'Berlin Motion Pictures Award 2025 \u2014 Best Documentary Film, Best Director, Best Cinematography, Best Composer',
  'Brooklyn International Cinefest 2025 \u2014 Educational Film; Film on Nature, Environment and Wildlife',
  'Druk International Film Festival, Bhutan 2025 \u2014 Best Director, Best Cinematography, Best Editing, Best Sound Design, Outstanding Achievement for Best Documentary, Outstanding Achievement for Film on Nature, Wildlife and Environment',
  'World Film Carnival Singapore 2025 \u2014 Documentary Films (Any Length), Best Director, Best Producer, Best Cinematography, Best Editor',
  'Los Angeles Short Film Award 2025 \u2014 Best First Time Director, Short Documentary',
  'LA Film and Documentary Award 2025 \u2014 Best Science and Climate Change Documentary',
  'Twilight Tokyo Film Festival 2025 \u2014 Best Short Documentary Film',
  'Cleveland International Film Festival 2026 \u2014 Official Selection',
  'Colorado Environmental Film Festival 2026 \u2014 Official Selection, US Premiere',
  'International Environmental Film Festival of Chefchaouen 2025 \u2014 Official Competition, Professional Short Films',
  'British Columbia Environmental Film Festival 2025 \u2014 Finalist',
  'Diversity in Cannes Short Film Showcase 2026 \u2014 Official Selection',
  'Art Speaks Out, ikonoTV 2025 \u2014 Official Selection',
  'Green Screen Environmental Film Festival 2025 \u2014 Official Selection',
  'Cannes Indie Shorts Awards 2025 \u2014 Semifinalist',
  'Venezia Shorts 2026 \u2014 Semifinalist',
  'New York Indie Shorts Awards 2026 \u2014 Semifinalist',
]

// Host a screening. The film is free; we ask first as a courtesy, and because
// the Colorado festival and PBS12 both asked before showing it.
export const hosting = {
  heading: 'Host a screening',
  body: [
    'If you would like to screen it for a school, a company or a community group, just drop us an email and we would be able to support your event with captions, a poster and anything else useful.',
  ],
  email: 'info@thegirlandherpiano.com',
}

// The mark is the diamond weave from the kira worn by the women of Laya, so it
// belongs to the film rather than being decoration. Red on transparent, so it
// reads on every band.
export const mark = '/assets/gap/kira-mark.png'
// the same mark in the site blue, swapped in on hover
export const markHover = '/assets/gap/kira-mark-blue.png'

// The film's wordmark, white on transparent, for the top of every page except
// the home page, where the hero already carries it large.
export const titleMark = '/assets/gap/title-white.png'

export const imdb = 'https://www.imdb.com/title/tt37798371/'

// ---------------------------------------------------------------------------
// CLEVELAND - leads both pages
//
// Wording is deliberate. "Academy Award qualifying" describes the festival,
// not the film: qualifying status attaches to the winners of CIFF's three
// short-film jury awards, and the film was an Official Selection. Do not
// reword this to imply otherwise.
// ---------------------------------------------------------------------------
export const cleveland = {
  date: '11 and 18 April 2026',
  note: 'The 50th anniversary edition, an Academy Award qualifying festival for short films. Screened twice as a Cleveland Premiere in Family Shorts Program 2.',
  links: [],
  dates: '11 and 18 April 2026',
  title: 'Cleveland International Film Festival',
  place: 'Cleveland, Ohio',
  result: 'Official Selection, CIFF50',
  note: 'The 50th anniversary edition, an Academy Award qualifying festival for short films. Screened twice as a Cleveland Premiere in Family Shorts Program 2.',
  url: 'https://www.clevelandfilm.org/films/the-girl-and-her-piano-2026/',
  reel: 'https://www.instagram.com/reel/DXS4r9yCr6j/',
  layout: 'image-right', band: 'off-white', split: '40-60',
  // Two photographs, shown at their own proportions. Nothing is cropped to a
  // shape. The second is deliberately small.
  images: [
    { src: '/assets/screenings/cleveland-01.jpg', alt: 'The film on screen in the Allen Theatre, Cleveland, with the audience seated' },
  ],
}

// ---------------------------------------------------------------------------
// AWARDS - the five that lead
// ---------------------------------------------------------------------------
export const awards = [
  { festival: 'Global Trend Climate Change Film Festival (GTCF)', year: '2026',
    prizes: ['Joint Winner, Best Climate Film Award'], url: '' },
  { festival: 'Berlin Motion Pictures Award', year: '2025',
    prizes: ['Best Documentary Film', 'Best Director', 'Best Cinematography', 'Best Composer'], url: '' },
  { festival: 'Brooklyn International Cinefest', year: '2025',
    prizes: ['Educational Film', 'Film on Nature, Environment and Wildlife'], url: '' },
  { festival: 'Los Angeles Short Film Award', year: '2025',
    prizes: ['Best First Time Director, Short Documentary'], url: '' },
  { festival: 'LA Film and Documentary Award', year: '2025',
    prizes: ['Best Science and Climate Change Documentary'], url: '' },
]

// Kept at lower weight rather than deleted. Deleting these would change the
// 21 and 18 above, and those numbers are in the YouTube description too.
export const alsoAwarded = [
  { festival: 'Druk International Film Festival, Bhutan', year: '2025',
    prizes: 'Best Director, Best Cinematography, Best Editing, Best Sound Design, and two Outstanding Achievement awards', url: '' },
  { festival: 'World Film Carnival Singapore', year: '2025',
    prizes: 'Documentary Films (Any Length), Best Director, Best Producer, Best Cinematography, Best Editor', url: '' },
  { festival: 'Twilight Tokyo Film Festival', year: '2025',
    prizes: 'Best Short Documentary Film', url: '' },
]

export const selections = [
  { festival: 'Colorado Environmental Film Festival', year: '2026', result: 'Official Selection',
    url: 'https://ceff2026.eventive.org/films/the-girl-and-her-piano-oc-6930ad933876fd39d467d1cb' },
  { festival: 'International Environmental Film Festival of Chefchaouen, Morocco', year: '2025',
    result: 'Official Competition, Professional Short Films', url: '' },
  { festival: 'British Columbia Environmental Film Festival', year: '2025', result: 'Finalist',
    url: 'https://www.bceff.org' },
  { festival: 'Diversity in Cannes Short Film Showcase', year: '2026', result: 'Official Selection', url: '' },
  { festival: 'Art Speaks Out, ikonoTV', year: '2025', result: 'Official Selection', url: '' },
  { festival: 'Green Screen Environmental Film Festival', year: '2025', result: 'Official Selection', url: '' },
  { festival: 'Cannes Indie Shorts Awards', year: '2025', result: 'Semifinalist', url: '' },
  { festival: 'Venezia Shorts', year: '2026', result: 'Semifinalist', url: '' },
  { festival: 'New York Indie Shorts Awards', year: '2026', result: 'Semifinalist', url: '' },
]

// ---------------------------------------------------------------------------
// BROADCAST - sits inside the screenings banner, above everything
//
// No audience figures. None have been supplied for PBS12 or CEFF 4 Classrooms
// and none are invented. If either sends numbers, they go here.
// ---------------------------------------------------------------------------
export const broadcast = {
  heading: 'Broadcast and streaming on the Public Broadcasting Service',
  columns: [
    { label: 'On television',
      text: 'Colorado Public Television PBS12. Four nights in the Earth Week line-up, 19 to 22 April 2026, and two preview nights on 15 and 19 February for the 20th Colorado Environmental Film Festival.' },
    { label: 'In classrooms',
      text: 'Selected for CEFF 4 Classrooms 2026. Free to K-12 teachers and classrooms across Colorado and nearby regions, 23 February to 31 May 2026.' },
    { label: 'On PBS',
      text: 'Streaming at pbs.org until 21 April 2027, as part of the Colorado Environmental Film Festival Film Showcase 2026.' },
  ],
  link: { href: 'https://www.pbs.org/video/the-girl-and-her-piano-il4or1/', label: 'Watch on PBS' },
}

// ---------------------------------------------------------------------------
// PAGE HEADERS
//
// Both photographs are black and white as shot. Nothing is tinted. The only
// thing over them is a neutral black gradient at the top and bottom plus a
// soft band behind the centred title, because the middle of both frames is
// the busiest part and off-white type needs something to sit on.
//
// `focus` is the horizontal crop centre, 0 is hard left and 1 hard right. It
// is the one value to change if the crop lands badly, on desktop or on a
// phone. No second image is needed: both photographs survive a portrait crop.
// ---------------------------------------------------------------------------
export const headers = {
  reference: {
    image: '/assets/gap/reference-header.jpg',
    focus: '50% 62%',
    alt: 'The closing ceremony at the Royal Highland Festival, Laya, Bhutan',
  },
  awards: {
    image: '/assets/gap/awards-header.jpg',
    focus: '30% 40%',
    alt: 'A boy on a yak raising his hand towards the mountains above Laya, Bhutan',
  },
  screenings: {
    image: '/assets/gap/screenings-header.jpg',
    focus: '44% 50%',
    alt: 'Dancers mid-leap at the Royal Highland Festival in Laya, Bhutan',
  },
}

// ---------------------------------------------------------------------------
// FESTIVAL SCREENINGS - festivals that put the film in a room, after Cleveland
//
// PHOTOS: one per event. Upload to /assets/screenings/ at 644. Colorado,
// British Columbia and Chefchaouen have none, so they render as text.
// ---------------------------------------------------------------------------
export const festivalScreenings = [
  {
    // US Premiere. Taken from CEFF's own listing page, which also corrected
    // the venue, the encore scope and the classroom start date. The email
    // said 22 February; the festival page says 23 February.
    date: '20 February 2026',
    title: 'Colorado Environmental Film Festival',
    place: 'Bunker Auditorium, Green Center, Colorado School of Mines, Golden, Colorado',
    note: 'The film\u2019s US Premiere, at the 20th edition of the festival. Screened at 10am, with an online encore in the Shorts Collection, US only, from 23 February to 1 March 2026.',
    url: 'https://ceff2026.eventive.org/films/the-girl-and-her-piano-oc-6930ad933876fd39d467d1cb',
    layout: 'type',
    images: [], reel: null, links: [],
  },
  {
    date: '4 November 2025',
    title: 'British Columbia Environmental Film Festival',
    place: 'VIFF Centre, Vancouver, Canada',
    note: 'In-person premiere at the VIFF Centre as part of Voices for Planet Earth, with the full programme online from 1 to 30 November. The film placed in the festival\u2019s ten most watched every week of its run.',
    url: 'https://www.bceff.org',
    layout: 'type',
    images: [], reel: null,
    // The festival's own weekly Top 10 posts. Positions 4, 5, 8 and 6.
    // These are Facebook share links; open each one and copy the canonical
    // post URL from the address bar if you want something more durable.
    links: [
      { label: 'Finalist announcement', href: 'https://www.facebook.com/share/p/1GFoC1iEAn/' },
      { label: 'Week one', href: 'https://www.facebook.com/share/p/1ET46TGvio/' },
      { label: 'Week two', href: 'https://www.facebook.com/share/p/1JJcCw2h6Q/' },
      { label: 'Week three', href: 'https://www.facebook.com/share/p/19Pymc4HHQ/' },
      { label: 'Week four', href: 'https://www.facebook.com/share/p/19FGXjVK9j/' },
    ],
  },
  {
    date: '11 September 2025',
    title: '14th International Environmental Film Festival of Chefchaouen',
    place: 'Maison des Jeunes, Chefchaouen, Morocco',
    note: 'Selected for the Official Competition, Professional Short Films, one of 24 films chosen from over 200 submitted worldwide, and the only entry from Singapore in its category. Screened at 16h30. Elaine Lim was invited as an official guest with costs covered. FIFE is a zero plastic festival.',
    url: 'https://festival.assated.com',
    links: [{ label: 'The festival\u2019s selection announcement', href: 'https://www.facebook.com/share/p/1BepoMLPQS/' }],
    layout: 'type',
    images: [], reel: null,
  },
]

// ---------------------------------------------------------------------------
// OTHER SCREENINGS - not festivals
// ---------------------------------------------------------------------------
export const otherScreenings = [
  {
    date: '2 July 2025',
    title: 'Aboard the Sylvia Earle, Arctic',
    place: 'Arctic Ocean',
    note: 'Screened on board during the BIG ACE expedition, run by Aurora Expeditions with Ocean Geographic.',
    url: '',
    layout: 'type',
    // UNVERIFIED: the ship sails both poles and the photograph carries no EXIF
    // date or GPS. Confirm this frame is the Arctic voyage, not Antarctica,
    // before it sits under a July 2025 heading.
    images: [], reel: null, links: [],
  },
  {
    date: '7 November 2024',
    title: 'Blue Water EduFest 2024',
    place: 'ONE\u00b015 Marina, Sentosa, Singapore',
    note: 'The third edition of the festival, with the conference programme by Ocean Geographic and Dr Sylvia Earle as keynote speaker.',
    url: '',
    layout: 'type',
    images: [],
    reel: 'https://www.instagram.com/reel/DCTJZdGohmT/',
    links: [],
  },
  {
    date: '8 October 2024',
    title: 'Singapore Premiere',
    place: 'Guoco Midtown Networking Hub, Singapore',
    note: 'Sponsored by Kerry Consulting, with a Q&A moderated by Cecelia Koh.',
    url: '',
    // The premiere closes the page. 22 photographs in a masonry grid, with the
    // room, the performance, the panel and the Bhutanese guests running large.
    layout: 'masonry', band: 'off-white',
    featured: [0, 1],
    images: [
      { src: '/assets/screenings/premiere-01.jpg', alt: 'The audience seated for the premiere, with the piano at the front of the room' },
      { src: '/assets/screenings/premiere-02.jpg', alt: 'Hillary O\u2019Sullivan playing the piano to the room after the screening' },
      { src: '/assets/screenings/premiere-03.jpg', alt: 'The panel on stage in front of a slide listing the film\u2019s credits' },
      { src: '/assets/screenings/premiere-04.jpg', alt: 'The Q&A in progress' },
      { src: '/assets/screenings/premiere-05.jpg', alt: 'The team photographed together in front of the film poster' },
      { src: '/assets/screenings/premiere-06.jpg', alt: 'The audience applauding at the end of the screening' },
      { src: '/assets/screenings/premiere-07.jpg', alt: 'The Girl and Her Piano premiere, Guoco Midtown, Singapore' },
      { src: '/assets/screenings/premiere-09.jpg', alt: 'The Girl and Her Piano premiere, Guoco Midtown, Singapore' },
      { src: '/assets/screenings/premiere-15.jpg', alt: 'Guests from Bhutan watching the screening' },
      { src: '/assets/screenings/premiere-21.jpg', alt: 'The Girl and Her Piano premiere, Guoco Midtown, Singapore' },
      { src: '/assets/screenings/premiere-22.jpg', alt: 'The Girl and Her Piano premiere, Guoco Midtown, Singapore' },
    ],
    reel: 'https://www.instagram.com/reel/DBqkKZlSGEX/',
    links: [],
  },
]

export const onlineScreenings = [
  { title: 'Art Speaks Out, ikonoTV', note: 'Streamed globally during COP30, Bel\u00e9m, 10 to 21 November 2025.', url: '' },
  { title: 'Green Screen Environmental Film Festival', note: 'Trinidad and Tobago.', url: '' },
  { title: 'Cannes Indie Shorts Awards', note: 'Semifinalist, showcased in the Cannes New Waves online event.', url: '' },
  { title: 'Venezia Shorts', note: 'Semifinalist.', url: '' },
  { title: 'New York Indie Shorts Awards', note: 'Semifinalist.', url: '' },
]

// ---------------------------------------------------------------------------
// LAURELS - awards page, blue band at the foot. Seven wins, then eleven
// selections at smaller size.
//
// All white on transparent, and all trimmed of surrounding empty space, so
// eighteen different festival proportions read as one set. Add a laurel later
// and you must trim it too or it will look undersized.
//
// Twilight Tokyo sits with the selections because its white laurel reads
// OFFICIAL SELECTION. The film did win Best Short Documentary Film there. A
// winner laurel exists but only in dark; export it in white and move the line
// up to laurelsWon if you would rather it led.
// ---------------------------------------------------------------------------
// The few worth showing over the trailer on the home page. The full set is in
// the scroller further down.
// The four festivals that put the film in front of an audience, plus the one
// outright win. Change this list and the hero changes.
export const heroLaurels = [
  { src: '/assets/laurels/cleveland-white.png' },
  { src: '/assets/laurels/colorado-white.png' },
  { src: '/assets/laurels/chefchaouen-white.png' },
  { src: '/assets/laurels/british-columbia-white.png' },
  { src: '/assets/laurels/gtcf-white.png' },
]

export const laurelsWon = [
  { src: '/assets/laurels/gtcf-white.png', alt: 'Global Trend Climate Change Film Festival, Best Climate Film Award 2026' },
  { src: '/assets/laurels/berlin-white.png', alt: 'Berlin Motion Pictures Award, Winner 2025' },
  { src: '/assets/laurels/brooklyn-white.png', alt: 'Brooklyn International Cinefest, Winner 2025' },
  { src: '/assets/laurels/la-short-film-white.png', alt: 'Los Angeles Short Film Award, Winner 2025' },
  { src: '/assets/laurels/la-film-doc-white.png', alt: 'LA Film and Documentary Award, Winner 2025' },
  { src: '/assets/laurels/world-film-carnival-white.png', alt: 'World Film Carnival Singapore, Winner 2025' },
  { src: '/assets/laurels/druk-white.png', alt: 'Druk International Film Festival, Bhutan, Winner 2025' },
]

export const laurelsSelected = [
  { src: '/assets/laurels/cleveland-white.png', alt: 'Cleveland International Film Festival, Official Selection' },
  { src: '/assets/laurels/colorado-white.png', alt: 'Colorado Environmental Film Festival, Official Selection 2026' },
  { src: '/assets/laurels/chefchaouen-white.png', alt: 'International Environmental Film Festival of Chefchaouen, Official Selection 2025' },
  { src: '/assets/laurels/british-columbia-white.png', alt: 'British Columbia Environmental Film Festival, Finalist 2025' },
  { src: '/assets/laurels/art-speaks-out-white.png', alt: 'Art Speaks Out on ikonoTV, Official Selection 2025' },
  { src: '/assets/laurels/green-screen-white.png', alt: 'Green Screen Environmental Film Festival, Official Selection 2025' },
  { src: '/assets/laurels/diversity-in-cannes-white.png', alt: 'Diversity in Cannes Short Film Showcase, Official Selection 2026' },
  { src: '/assets/laurels/twilight-tokyo-white.png', alt: 'Twilight Tokyo Film Festival, Official Selection 2025' },
  { src: '/assets/laurels/cannes-indie-white.png', alt: 'Cannes Indie Shorts Awards, Semifinalist' },
  { src: '/assets/laurels/venezia-white.png', alt: 'Venezia Shorts, Semifinalist' },
  { src: '/assets/laurels/new-york-indie-white.png', alt: 'New York Indie Shorts Awards, Semifinalist' },
]
